import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router'
import PaginationList from "../../common/Paginator/PaginationList";
import NewsDetail from "../../common/NewsDetail/NewsDetail";
import InterestSearchTag from "../../common/InterestSearchTag/InterestSearchTag";
import HotRank from "../../common/HotRank/HotRank";
import moment from "moment";
import ellipsisContent from "../../utils/EllipsisContent";
import globalStyle from "../../styles/globalStyle";
import ellipsis from "../../styles/ellipsis.module.css";
import NewsItem from "../../common/NewsItem/NewsItem";
import newsDetailPushTarget from "../../utils/NewsDetailPushTarget";



const SearchResult =(props)=>{
    const {match, history} = props;
    const {searchKeys, tab, id} = match.params;
    const [newsDetailVisible, setNewsDetailVisible] = useState(false);

    useEffect(() => {
        setNewsDetailVisible(!!match.params.id)
        // console.log('match变化了,searchKeys='+searchKeys);
    }, [match]);


    return(
        <div style={{width: 1200, display: 'flex'}}>
        {
            newsDetailVisible
            ?   <NewsDetail url={`/api/${tab}?id=${id}`}/>
            :   <PaginationList
                    title="搜索结果"
                    url={`/api/SearchTag?keys=${searchKeys}`}
                    requestOption={{params: {keys:searchKeys},headers:{Accept: "application/json;version=2"}}}
                    renderItem={item => {
                        const {id, title, cover_link, change_time, content = '', tab} = item;
                        return(
                            <div
                                key={id}
                                style={{display: 'flex', padding: 16, cursor: 'pointer'}}
                                onClick={() => {
                                    history.push({ pathname: `/${newsDetailPushTarget(tab)}/${id}`});
                                }}
                            >
                                <img src={cover_link} style={{width: 180, height: 120}}/>
                                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingLeft: 16, width: 692}}>
                                    <div style={{...globalStyle.flexSpaceBetweenRow,marginBottom: 16}}>
                                        <span style={{fontSize: 18, fontWeight: 400, color: '#333333'}}>{title}</span>
                                        <span>{moment(change_time).format('YYYY-MM-DD')}</span>
                                    </div>
                                    <span className={ellipsis.ellipsis} style={{lineHeight: '25px', height: 50}}>
                                        {ellipsisContent(content)}
                                    </span>
                                </div>
                            </div>
                        );
                    }}
                />
        }
        <div style={{marginLeft: 16}}>
            <InterestSearchTag/>
            <div style={{height: 16}}/>
            <HotRank/>
        </div>
    </div>
    );
}

export default  connect()(withRouter(SearchResult));